import React from 'react';

const PhoneSvg = (
  props: React.SVGAttributes<SVGElement> & { color?: string },
): React.ReactElement => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.6687 5.40609C26.1354 5.49359 26.5146 5.72692 26.8062 6.10609C27.0979 6.45609 27.2437 6.879 27.2437 7.37484C27.2437 9.99984 26.7187 12.5228 25.6687 14.9436C24.6479 17.3353 23.2625 19.4061 21.5125 21.1561C19.7917 22.8769 17.7354 24.2478 15.3437 25.2686C12.9521 26.2894 10.4292 26.7998 7.77499 26.7998C7.30832 26.7998 6.88541 26.654 6.50624 26.3623C6.15624 26.0707 5.93749 25.6915 5.84999 25.2248L4.88749 21.1123C4.77082 20.6457 4.81457 20.1936 5.01874 19.7561C5.25207 19.3186 5.60207 19.0123 6.06874 18.8373L10.4875 16.9123C10.8958 16.7373 11.3187 16.7082 11.7562 16.8248C12.1937 16.9415 12.5583 17.1748 12.85 17.5248L14.25 19.2748C16.6125 17.9915 18.4354 16.1686 19.7187 13.8061L17.9687 12.4061C17.6187 12.1144 17.3854 11.7498 17.2687 11.3123C17.1812 10.8748 17.2104 10.4519 17.3562 10.0436L19.2812 5.62484C19.4854 5.15817 19.7917 4.82275 20.2 4.61859C20.6375 4.38525 21.0896 4.32692 21.5562 4.44359L25.6687 5.40609ZM7.86249 24.6998C10.9833 24.6998 13.8708 23.9269 16.525 22.3811C19.1792 20.8353 21.2792 18.7353 22.825 16.0811C24.3708 13.4269 25.1437 10.5394 25.1437 7.41859L21.1625 6.49984L19.325 10.8311L22.3 13.2373C21.3083 15.3957 20.1562 17.1165 18.8437 18.3998C17.5604 19.6832 15.8396 20.8353 13.6812 21.8561L11.275 18.8811L6.94374 20.7186L7.86249 24.6998Z"
      fill={props.color || '#001238'}
    />
  </svg>
);

export default PhoneSvg;
